import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import Admin from './pages/Admin';
import Account from './pages/Account';
import Strategy from './pages/Strategy';
import Backtest from './pages/Backtest';
import SectorAnalysis from './pages/SectorAnalysis';
import IdleTimeoutWarning from './components/IdleTimeoutWarning';
import { isAuthenticated } from './api/auth';
import { IdleTimeoutProvider, useIdleTimeoutContext } from './context/IdleTimeoutContext';

function PrivateRoute({ children }) {
  return isAuthenticated() ? children : <Navigate to="/login" />;
}

function PublicRoute({ children }) {
  return isAuthenticated() ? <Navigate to="/dashboard" /> : children;
}

function AppContent() {
  const { showWarning, remainingSeconds, extendSession, logout } = useIdleTimeoutContext();

  return (
    <>
      {showWarning && (
        <IdleTimeoutWarning
          remainingTime={remainingSeconds}
          onExtend={extendSession}
          onLogout={logout}
        />
      )}
      <Routes>
        <Route path="/login" element={
          <PublicRoute>
            <Login />
          </PublicRoute>
        } />
        <Route path="/register" element={
          <PublicRoute>
            <Register />
          </PublicRoute>
        } />
        <Route path="/dashboard" element={
          <PrivateRoute>
            <Dashboard />
          </PrivateRoute>
        } />
        <Route path="/admin" element={
          <PrivateRoute>
            <Admin />
          </PrivateRoute>
        } />
        <Route path="/account" element={
          <PrivateRoute>
            <Account />
          </PrivateRoute>
        } />
        <Route path="/strategy" element={
          <PrivateRoute>
            <Strategy />
          </PrivateRoute>
        } />
        <Route path="/backtest" element={
          <PrivateRoute>
            <Backtest />
          </PrivateRoute>
        } />
        <Route path="/sector" element={
          <PrivateRoute>
            <SectorAnalysis />
          </PrivateRoute>
        } />
        <Route path="/" element={<Navigate to="/dashboard" />} />
      </Routes>
    </>
  );
}

function App() {
  return (
    <Router>
      <IdleTimeoutProvider>
        <AppContent />
      </IdleTimeoutProvider>
    </Router>
  );
}

export default App;
